// extracted by mini-css-extract-plugin
export default {"SMContainer":"Tiles_SMContainer__Vxgnq","link":"Tiles_link__e1cQj","title":"Tiles_title__Qq--g","number":"Tiles_number__yUE6h"};